<div style="margin: 20px;">

    <h2 mat-dialog-title>{{ data.title }} - {{ data.status }}</h2>
    <div>
        <mat-dialog-content>
            <div style="text-align: center;">
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>Comments</mat-label>
                        <textarea matInput placeholder="Comments" [(ngModel)]="userComments"></textarea>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="outline">
                        <mat-label>SMS Comments</mat-label>
                        <textarea matInput placeholder="SMS Comments" [(ngModel)]="additionalComments"></textarea>
                    </mat-form-field>
                </div>
                <!-- {{ data.jobCardData.jobCloseOtp }} -->
                <div *ngIf="data.status === 'CLOSED' && !isAdmin">
                    <mat-form-field appearance="outline">
                        <mat-label>OTP</mat-label>
                        <input matInput placeholder="OTP" [(ngModel)]="otp" maxlength="6"/>
                    </mat-form-field>
                </div>
            </div>
        </mat-dialog-content>
    </div>
    <mat-dialog-actions align="center">
        <button mat-stroked-button (click)="onBackClick()">Back</button>
        <button mat-flat-button [mat-dialog-close]="event()" (click)="onOkay()">Okay</button>
    </mat-dialog-actions>
</div>